export enum OrderTypes {
  SELL = 'SELL',
  BUY = 'BUY'
}

export const AllOrderTypes = [
  {
    name: 'Продажа',
    id: OrderTypes.SELL
  },
  {
    name: 'Покупка',
    id: OrderTypes.BUY
  }
]
